import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '@/views/layout/Main'

import Home from '@/views/Home'
import ProductList from '@/views/product/List'
// import ProductSearch from '@/views/product/Search'
import ProductDetail from '@/views/product/Detail'
import ArticleList from '@/views/article/List'
import ArticleDetail from '@/views/article/Detail'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      component: Main,
      children: [
        // 新闻页
        {
          name: 'product/search',
          path: 'product/search',
          component: ProductList
        },

        // 新闻页
        {
          name: 'product/detail',
          path: 'product/:id',
          component: ProductDetail
        },

        // 文档页
        {
          name: 'article/detail',
          path: 'article/:id',
          component: ArticleDetail
        },

        // 问答页
        {
          name: 'product/list',
          path: 'product',
          component: ProductList
        },
        {
          name: 'article/list',
          path: 'article',
          component: ArticleList
        },
        // 首页
        {
          path: '',
          component: Home
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js